import { Alert, Flex } from '@cmpsr/components';

const getCACToastRender = () => {
  const render = ({ onClose }: { onClose: () => void }) => (
    <Alert variant="subtle" status="error">
      <Alert.Icon />
      <Flex direction={'column'} pr="1.5rem">
        <Alert.Title>Thanks for your interest in Catch</Alert.Title>
        <Alert.Description>
          Our Beta Test experience is currently full, but we will notify you when additional spots become available.{' '}
          <b>Your credit card has not been charged</b>.
        </Alert.Description>
        <Alert.CloseButton onClick={onClose} color="text-primary" />
      </Flex>
    </Alert>
  );

  return render;
};

export default getCACToastRender;
